<div>
  <app-intec-date-picker class="form-field" [placeholder]="label" [(ngModel)]="value" (dateChange)="valueChanged($event)"
  [required]="required" [min]="min" [max]="max" [disabled]="readonly" #ip="ngModel" attr.aria-label="{{label}}"></app-intec-date-picker>
  <validation-errors [control]="ip" [min]="min" [max]="max"></validation-errors>
</div>
